/* Added by MORYARTY (MOD-099) — lazy loader for the search overlay's zero state.

   The empty-input content (bestsellers grid + collections list) is NOT rendered
   into every page's HTML — it is fetched once from the Section Rendering API
   (?section_id=moryarty-search-zero) and injected into [data-search-zero] inside
   the search modal. Fetch triggers on hovering/tapping the search icon (prefetch)
   or on first modal open, whichever comes first — so by the time the overlay is
   visible the content is there or arriving. The [data-section-url] attribute
   carries routes.root_url so each language/market fetches its localized render.
   On fetch failure the flag resets so a later open retries. */
(function () {
  'use strict';

  function init() {
    /* bind every instance — the header renders the search modal TWICE in some
       logo-position layouts; a single querySelector would leave the second
       modal's zero state permanently empty */
    var zeros = document.querySelectorAll('[data-search-zero]');
    for (var i = 0; i < zeros.length; i++) bind(zeros[i]);
  }

  /* MOD-111 — optional random empty state. With the "Shuffle the empty state" setting on,
     the section renders the WHOLE pool (up to 50) and marks the grid [data-msz-shuffle];
     we pick a random MSZ_KEEP of them so a different selection shows per page load.

     Client-side on purpose: Liquid has no randomness and this section's render is cached
     by Shopify, so a server-side pick would freeze to the same "random" set for everyone.
     Safe here (unlike the MOD-097 collection cards) because the zero state is a lazily
     fetched dropdown panel — reordering it can't shift page layout.

     ⚠ The trim MUST happen while the markup is still in the DOMParser document, BEFORE
     it is injected. Measured on the live site: capped tiles are display:none but their
     lazy <img>s STILL download once they're in the live DOM — so injecting all 50 would
     pull ~50 images for a dropdown. A DOMParser document is inert (no resource fetches),
     so dropping the extras there means only the kept tiles ever load an image: same image
     cost as before, just a random selection. */
  var MSZ_KEEP = 14; // matches the non-shuffled render; CSS caps the visible rows per breakpoint

  function pickRandomSubset(section) {
    var grid = section.querySelector('.moryarty-search-grid--showcase[data-msz-shuffle]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.children);
    if (items.length <= MSZ_KEEP) return; // nothing to choose from
    for (var i = items.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }
    while (grid.firstChild) grid.removeChild(grid.firstChild);
    for (var k = 0; k < MSZ_KEEP; k++) grid.appendChild(items[k]);
  }

  function bind(zero) {
    if (zero.dataset.mszBound === '1') return;
    zero.dataset.mszBound = '1';

    var details = zero.closest('details');
    var loading = false;
    var loaded = false;

    function load() {
      if (loaded || loading) return;
      loading = true;
      var root = zero.getAttribute('data-section-url') || '/';
      var joiner = root.indexOf('?') === -1 ? '?' : '&';
      fetch(root + joiner + 'section_id=moryarty-search-zero')
        .then(function (r) {
          return r.ok ? r.text() : null;
        })
        .then(function (text) {
          loading = false;
          if (!text) return;
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('#shopify-section-moryarty-search-zero');
          if (section) {
            /* MOD-111 — pick the random subset while still detached (inert), so only
               the kept tiles ever fetch an image. No-op when the setting is off. */
            pickRandomSubset(section);
            zero.innerHTML = section.innerHTML;
            loaded = true;
          }
        })
        .catch(function () {
          loading = false;
        });
    }

    if (details) {
      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('pointerenter', load);
        summary.addEventListener('touchstart', load, { passive: true });
      }
      details.addEventListener('toggle', function () {
        if (details.open) load();
      });
    } else {
      load();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
